
import * as React from "react";
import { useTranslation } from "react-i18next";
import CommonContainer from "../../components/common/container/CommonContainer";
import ViewTicket from "../../components/Admin/view/ViewTicket";


const View: React.FC = () => {

    const { t } = useTranslation('translation');
    return (
            <CommonContainer title={t("ticketDetails")} description={t("viewTicketDetails")} backButtonurl= "/admin/dashboard">
                <ViewTicket />
            </CommonContainer>
    );
};

export default View;
